import { ButtonPrimary } from '@/components/Form';
import Modal from '@/components/Modal';
import { Body } from '@/components/Typography';
import { Box, Spacer } from '@chakra-ui/react';
import { useState, type FC } from 'react';
import type { IntroStepProps } from './types';
import { useAmplifyMutation } from '@/hooks/useAmplifyMutation';
import type { PagedResponse } from 'api-response';
import { useSetupTwoFAStore } from '../useSetupTwoFAStore';

type Setup2FAResponse = {
  secret_code: string;
  qr_code: string;
};

const IntroStep: FC<IntroStepProps> = ({ onNext  }) => {
  const setupTwoFA = useSetupTwoFAStore((s) => s.setupTwoFA);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  /** React query mutation */
  const mutation = useAmplifyMutation<PagedResponse<Setup2FAResponse>>({
    method: 'post',
    apiName: 'v1',
    path: '/auth/2fa/setup',
    mutationOptions: {
      onSuccess: async (response) => {
        const {secret_code, qr_code} = response?.data;
        setupTwoFA({secretCode: secret_code, qrCode: qr_code});
        onNext();
      },
      onError: (e) => {
        console.error(e);
      },
      onSettled: () => {
        setIsLoading(false);
      }
    },
  });

  const handleSetup = () => {
    setIsLoading(true);
    mutation.mutate();
  }

  return (
    <Modal
      disabled
      data-testid="modal_setup2fa_intro"
      onClose={() => {}}
      isOpen
      noMaxHeight={true}
      maxWidth={'327px'}
      noHeader
      hasCloseButton={false}
    >
      <Box textAlign="center">
        <img
          alt="2fa"
          src="/assets/images/2fa/prompt.png"
          style={{ width: '264px', height: '149px' }}
        />
        <Spacer h="24px" />
        <Body variant="Bold16" color="darkWillow">
          Tambah Proteksi Akunmu
        </Body>
        <Spacer h="8px" />
        <Body variant="Default14" color="shade04">
          Aktifkan verifikasi dua langkah untuk keamanan ekstra.
        </Body>
        <Spacer h="16px" />
        <ButtonPrimary width="100%" onClick={handleSetup} loadingText="Aktifkan Keamanan Tambahan" isLoading={isLoading}>
          Aktifkan Keamanan Tambahan
        </ButtonPrimary>
      </Box>
    </Modal>
  )
}

export default IntroStep;
